export class CellFormatHelper {
    static getFormatForColumnType(columnTypeId, value = null) {
        // Initialize format with default values
        const format = {
            numFmt: '@', // Default text format
            alignment: {
                horizontal: 'left',
                vertical: 'center', // Default vertical alignment
                wrapText: true
            }
        };

        switch (columnTypeId) {
            case 'DATE':
            case 'START_DATE':
            case 'END_DATE':
                // Use UTC date for formatting decision if available
                const dateValue = value?.date ? new Date(value.date) : null;
                const isDateOnly = value?.isDateOnly ?? (dateValue ? dateValue.getUTCHours() === 0 && dateValue.getUTCMinutes() === 0 && dateValue.getUTCSeconds() === 0 : false);

                format.numFmt = isDateOnly ? 'dd/mm/yyyy' : 'dd/mm/yyyy h:mm';
                format.alignment.horizontal = 'left';
                break;
                
            case 'RATING':
            case 'NUMBER':
                format.numFmt = '0'; // Simple integer format
                format.alignment.horizontal = 'right';
                break;
                
            case 'PERCENTAGE':
                format.numFmt = '0.00%';
                format.alignment.horizontal = 'right';
                break;
                
            case 'MULTI_LINE_TEXT':
                format.numFmt = '@'; // Text format
                format.alignment.wrapText = true;
                format.alignment.vertical = 'center'; // Align multi-line text to top
                break;
                
            case 'URL':
            case 'EMAIL':
                format.numFmt = '@';
                // Optionally set font color to blue and underline via cell.font directly later?
                // Or handle it in SheetStyleHelper if all links should look the same.
                break;
                
            case 'SINGLE_LINE_TEXT':
            case 'SELECT':
            case 'STATUS':
            default:
                // Use default format values (Text, left, bottom, no wrap)
                format.numFmt = '@';
                break;
        }

        // console.log(`Format decision for column type '${columnTypeId}':`, {
        //     format,
        //     numFmtExact: `Setting numFmt to: "${format.numFmt}"`,
        //     value,
        //     reason: this._getFormatReason(columnTypeId)
        // });

        return format;
    }

    static applyFormatToCell(cell, columnTypeId, value = null) {
        // console.log('Formatting cell:', {
        //     address: cell.address,
        //     columnType: columnTypeId,
        //     currentFormat: {
        //         numFmtExact: `Current numFmt: "${cell.numFmt}"`,
        //         alignment: cell.alignment
        //     }
        // });
        
        const format = this.getFormatForColumnType(columnTypeId, value);
        
        // Apply the number format
        cell.numFmt = format.numFmt;

        // Apply alignment - MERGE with existing alignment properties
        // This preserves any vertical/horizontal settings from SheetStyleHelper unless overridden
        cell.alignment = {
            ...(cell.alignment || {}), // Keep existing properties (like vertical: 'middle' from header)
            ...format.alignment       // Apply type-specific overrides (horizontal, wrapText, vertical)
        };

        // DO NOT set cell.font here - SheetStyleHelper handles base font.
        // Specific font changes (like color for links) could be handled
        // either in SheetStyleHelper or by checking type here and modifying cell.font directly.
        
        // console.log('Applied format:', {
        //     address: cell.address,
        //     columnType: columnTypeId,
        //     newFormat: {
        //         numFmtExact: `New numFmt: "${cell.numFmt}"`,
        //         alignment: cell.alignment
        //     }
        // });
        
        return cell;
    }

    static _getFormatReason(columnTypeId) {
        switch (columnTypeId) {
            case 'DATE':
            case 'START_DATE':
            case 'END_DATE':
                return 'Date format with right alignment for better readability';
            case 'RATING':
            case 'NUMBER':
                return 'Numeric format with right alignment for numbers';
            case 'PERCENTAGE':
                return 'Percentage format with right alignment';
            case 'MULTI_LINE_TEXT':
                return 'Text format with word wrap and top alignment for multi-line content';
            case 'SINGLE_LINE_TEXT':
            case 'SELECT':
            case 'STATUS':
                return 'Default text format with standard alignment';
            default:
                return 'Default text format applied';
        }
    }
}